import { memo, useCallback } from 'react';
import {
    Element,
    Icon,
    Menu,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import styles from './styles.module.scss';
import useAuth from '@zmedia/bm-soccer-ui/hooks/useAuth';

const settingMenu = [
    {
        icon: 'long-arrow-left',
        name: 'Trang tin tức',
        url: '/',
    },
];
function DropdownSetting({ isLogged = true }: { isLogged?: boolean }) {
    const { logout } = useAuth();
    const handleLogout = useCallback(() => {
        logout();
    }, []);

    const renderSetting = useCallback(() => {
        return settingMenu.map((item, index: number) => (
            <Menu.List.Item
                key={`parent.${index}`}
                className={styles['setting-item']}
            >
                <RouterLink to={item.url} title={item.name}>
                    <Icon icon={item.icon} />
                    <Element renderAs="span">{item.name}</Element>
                </RouterLink>
            </Menu.List.Item>
        ));
    }, [settingMenu]);

    return (
        <Menu.List>
            {renderSetting()}
            {isLogged && (
                <Menu.List.Item
                    onClick={handleLogout}
                    className={styles['setting-item']}
                >
                    <Element renderAs="a">
                        <Icon icon="sign-out-alt" />
                        <Element renderAs="span">Đăng xuất</Element>
                    </Element>
                </Menu.List.Item>
            )}
        </Menu.List>
    );
}

export default memo(DropdownSetting);
